var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUsermenuNotifications = function SvgIconUsermenuNotifications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "17px",
    viewBox: "0 0 15 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "898790F9-F762-4FF3-9B68-6F77FA0D27EA")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-menu",
    transform: "translate(-73.000000, -284.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-usermenu-notifications",
    transform: "translate(74.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58823529,1.94117647 C8.84069074,1.94117647 10.6666667,3.76715239 10.6666667,6.01960784 L10.6666667,10.0989083 L10.6666667,10.0989083 L13.1764706,13.1764706 L0,13.1764706 L2.50980392,10.0989083 L2.50980392,6.01960784 C2.50980392,3.76715239 4.33577984,1.94117647 6.58823529,1.94117647 Z",
    id: "Rectangle",
    stroke: "#90949C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58823529,0 C7.10803271,-9.54852354e-17 7.52941176,0.421379059 7.52941176,0.941176471 L7.52941176,2 L7.52941176,2 L5.64705882,2 L5.64705882,0.941176471 C5.64705882,0.421379059 6.06843788,9.54852354e-17 6.58823529,0 Z",
    id: "Rectangle",
    fill: "#90949C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70588235,15.0588235 C4.73055407,15.0877898 4.75566658,15.1162016 4.78120638,15.1440426 C5.26953764,15.6763731 5.91408633,16 6.62061605,16 C7.33225163,16 7.98100711,15.6716788 8.47058824,15.132469",
    id: "Path",
    stroke: "#90949C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUsermenuNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-usermenu-notifications.bb892565.svg";
export { ForwardRef as ReactComponent };